import { injectCss } from '@wix/ricos/css/ricos-viewer.global.inject';
import React from 'react';

import { useConverters } from './../../../pm-converters/context';
import type { PmJson } from './../../../pm-converters/types';
import type { RicosTheme } from './../../../ricos-types';
import { RicosViewer } from './../../../ricos-viewer-next';

import type { ResultContent } from '../../types';

type ResultContentViewerProps = {
  resultItem: ResultContent;
};

export const ResultContentViewer: React.FC<ResultContentViewerProps> = ({ resultItem }) => {
  const converters = useConverters();
  const [content, setContent] = React.useState(() =>
    converters.fromPm(resultItem.content as PmJson)
  );

  React.useEffect(() => {
    injectCss();
  }, []);

  React.useEffect(() => {
    setContent(converters.fromPm(resultItem.content as PmJson));
  }, [resultItem.content]);

  // Theme maps to @wix/design-system H1-H6 and P font sizes
  const theme: RicosTheme = React.useMemo(
    () => ({
      typography: {
        fontFamily: 'var(--wix-font-stack)',
      },
      customStyles: {
        h1: {
          fontSize: '28px',
          fontWeight: '700',
        },
        h2: {
          fontSize: '21px',
          fontWeight: '700',
        },
        h3: {
          fontSize: '18px',
          fontWeight: '700',
        },
        h4: {
          fontSize: '18px',
          fontWeight: '530',
        },
        h5: {
          fontSize: '15px',
          fontWeight: '530',
        },
        h6: {
          fontSize: '12px',
          fontWeight: '530',
        },
        p: {
          fontSize: '14px',
        },
      },
    }),
    []
  );

  return <RicosViewer content={content} theme={theme} />;
};
